import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { sendScreenEvent, sendTrackEvent, sendUIEvent } from '../../../common/utils/analytics-client';
import { Logger } from '../../../common/utils/logger';
import { updatePreferences } from '../../../controllers/storage-preferences/update-preferences';
import { CookieCategory } from '../../../types';
import { PresentationalPreferenceModal } from './presentational-preference-modal';
export const PreferenceModal = props => {
  // feature flag check
  if (!getBooleanFF('platform.moonjelly.browser-storage-controls')) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PreferenceModalImpl, props);
};
export const PreferenceModalImpl = ({
  onClose,
  onSubmit,
  showSuccessFlag,
  showErrorFlag
}) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const isEventSent = useRef(false);
  useEffect(() => {
    if (!isEventSent.current) {
      sendScreenEvent({
        name: 'cookieConsentModal'
      });
      isEventSent.current = true;
    }
  }, [isEventSent]);
  const [preferences, setPreferences] = useState({
    [CookieCategory.StrictlyNecessary]: true,
    [CookieCategory.Functional]: false,
    [CookieCategory.Marketing]: false,
    [CookieCategory.Analytics]: false,
    [CookieCategory.Unknown]: false
  });
  const handleOnSubmit = useCallback(async displayedTextMap => {
    const selectedPreferences = preferences;
    sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'confirm',
      source: 'cookieConsentModal'
    });
    try {
      await updatePreferences(selectedPreferences, displayedTextMap);
      sendTrackEvent({
        source: 'cookieConsentModal',
        action: 'submitted',
        actionSubject: 'cookieConsentPreferences'
      });
      showSuccessFlag === null || showSuccessFlag === void 0 ? void 0 : showSuccessFlag();
    } catch (e) {
      Logger.errorWithOperationalEvent({
        action: 'updatePreferencesError',
        attributes: {
          preferences: selectedPreferences
        },
        message: `Failed to update preferences from modal. ${e.message || ''}`
      });
      showErrorFlag === null || showErrorFlag === void 0 ? void 0 : showErrorFlag();
    }
    setIsModalOpen(false);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
  }, [preferences, onSubmit, showSuccessFlag, showErrorFlag]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isModalOpen && /*#__PURE__*/React.createElement(PresentationalPreferenceModal, {
    setPreferences: setPreferences,
    onSubmit: handleOnSubmit,
    onClose: onClose,
    setIsOpen: setIsModalOpen,
    preferences: preferences
  }));
};